// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 13 11"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.098 0.391624L3.93797 7.30162L2.03797 5.27162C1.68797 4.94162 1.13797 4.92162 0.737968 5.20162C0.347968 5.49162 0.237968 6.00162 0.477968 6.41162L2.72797 10.0716C2.94797 10.4116 3.32797 10.6216 3.75797 10.6216C4.16797 10.6216 4.55797 10.4116 4.77797 10.0716C5.13797 9.60162 12.008 1.41162 12.008 1.41162C12.908 0.491624 11.818 -0.318376 11.098 0.381624V0.391624Z"
      clipRule="evenodd"
    />
  </svg>
);
const IconTick = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconTick;
